// Coarse, non-identifying device/environment facts for the pilot audit
// (2026-10-06). Never the raw user-agent string. Everything optional —
// missing APIs (iOS Safari has no Battery or Network Information API)
// simply yield nulls.
const parseUA = (ua) => {
    const out = { browser_name: null, browser_version: null, os_name: null, os_version: null, device_model: null, device_form: "desktop" };
    if (!ua) return out;
    if (/iPhone|iPad|iPod/.test(ua)) { out.os_name = "iOS"; out.os_version = (ua.match(/OS (\d+[_.]\d+(?:[_.]\d+)?)/) || [])[1]?.replace(/_/g, ".") || null; out.device_model = /iPad/.test(ua) ? "iPad" : "iPhone"; out.device_form = /iPad/.test(ua) ? "tablet" : "mobile"; }
    else if (/Android/.test(ua)) { out.os_name = "Android"; out.os_version = (ua.match(/Android (\d+(?:\.\d+)*)/) || [])[1] || null; out.device_model = (ua.match(/Android [^;]+; ([^;)]+?)(?: Build|\))/) || [])[1] || null; out.device_form = /Mobile/.test(ua) ? "mobile" : "tablet"; }
    else if (/Windows/.test(ua)) { out.os_name = "Windows"; out.os_version = (ua.match(/Windows NT (\d+\.\d+)/) || [])[1] || null; }
    else if (/Mac OS X/.test(ua)) { out.os_name = "macOS"; out.os_version = (ua.match(/Mac OS X (\d+[_.]\d+(?:[_.]\d+)?)/) || [])[1]?.replace(/_/g, ".") || null; }
    else if (/Linux/.test(ua)) { out.os_name = "Linux"; }
    const b = [
        [/EdgA?\/(\d+)/, "Edge"], [/OPR\/(\d+)/, "Opera"], [/SamsungBrowser\/(\d+)/, "Samsung Internet"], [/CriOS\/(\d+)/, "Chrome"],
        [/FxiOS\/(\d+)/, "Firefox"], [/Chrome\/(\d+)/, "Chrome"], [/Firefox\/(\d+)/, "Firefox"], [/Version\/(\d+).*Safari/, "Safari"],
    ];
    for (const [re, name] of b) { const m = ua.match(re); if (m) { out.browser_name = name; out.browser_version = m[1]; break; } }
    return out;
};

export const collectDeviceContext = async () => {
    const n = typeof navigator !== "undefined" ? navigator : {};
    const ctx = { ...parseUA(n.userAgent) };
    try {
        if (n.userAgentData) {
            ctx.device_form = n.userAgentData.mobile ? "mobile" : ctx.device_form;
            if (n.userAgentData.platform) ctx.os_name = n.userAgentData.platform;
            const high = await n.userAgentData.getHighEntropyValues?.(["platformVersion", "model"]).catch(() => null);
            if (high) { if (high.platformVersion) ctx.os_version = high.platformVersion; if (high.model) ctx.device_model = high.model; }
        }
    } catch (e) { /* optional */ }
    ctx.language = n.language || null;
    ctx.languages = Array.isArray(n.languages) ? n.languages.slice(0, 5).join(",") : null;
    try { ctx.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch (e) { ctx.timezone = null; }
    if (typeof window !== "undefined" && window.screen) { ctx.screen_width = window.screen.width; ctx.screen_height = window.screen.height; ctx.device_pixel_ratio = window.devicePixelRatio || null; }
    ctx.hardware_concurrency = n.hardwareConcurrency || null;
    ctx.device_memory_gb = n.deviceMemory || null;
    ctx.touch_points = n.maxTouchPoints ?? null;
    const c = n.connection || n.mozConnection || n.webkitConnection;
    if (c) { ctx.network_type = c.effectiveType || null; ctx.downlink_mbps = c.downlink ?? null; ctx.rtt_ms = c.rtt ?? null; ctx.save_data = c.saveData ?? null; }
    try { const b = n.getBattery ? await n.getBattery() : null; if (b) { ctx.battery_level = b.level; ctx.battery_charging = b.charging; } } catch (e) { /* optional */ }
    ctx.online_at_register = typeof n.onLine === "boolean" ? n.onLine : null;
    try { ctx.ui_language = localStorage.getItem("ui_language") || null; } catch (e) { /* optional */ }
    return ctx;
};
